import React from 'react';
import { Nav, NavLink } from 'reactstrap';
import { ScorecardTabs } from '../ScorecardTabs';

interface PropTypes {
  activeTab: ScorecardTabs;
  setActiveTab: (tab: ScorecardTabs) => void;
}

export function ScorecardAssistantTabs(props: PropTypes) {
  const tabs = [
    ScorecardTabs.Summary,
    ScorecardTabs.Highlights,
    ScorecardTabs.KeyMoments,
  ];

  return (
    <Nav className='app-nav-tabs fs-6'>
      {tabs.map((tab) => {
        return (
          <NavLink
            key={tab}
            data-testid={tab}
            href='#'
            active={props.activeTab === tab}
            className='text-sm-center'
            onClick={() => props.setActiveTab(tab)}
          >
            {tab}
          </NavLink>
        );
      })}
    </Nav>
  );
}
